import React, { ReactNode } from "react";

interface TooltipProps {
  text: string;
  children: ReactNode;
  isVisible: boolean; // Ensures 'children' can be any valid React node
}

const Tooltip: React.FC<TooltipProps> = ({ isVisible, text, children }) => {
  // const [isVisible, setIsVisible] = useState(false);

  // const showTooltip = () => setIsVisible(true);
  // const hideTooltip = () => setIsVisible(false);

  return (
    <div
      className="relative w-full"

      // onMouseEnter={showTooltip}
      // onMouseLeave={hideTooltip}
    >
      {children}
      {isVisible && (
        <div className="absolute bottom-full left-1/2 mb-2 w-auto min-w-[7.125rem] -translate-x-1/2 transform">
          <div className="relative rounded-xl bg-white p-4 shadow-md">
            <p className="text-[0.875rem] font-normal leading-[1.3125rem] text-[#232323]">
              {text}
            </p>
            {/* Arrow */}
            <div className="absolute left-1/2 top-full h-3 w-3 -translate-x-1/2 -translate-y-1/2 rotate-45 transform bg-white"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
